import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Row, Col } from '@gympass/yoga'

import { homeExercising } from '@assets'

import {
  Bodytech,
  CiaAthletica,
  Bluefit,
  DeRose,
  Zenklub,
  Tecnonutri,
  ZenThree,
  BtfitThree,
} from '@assets/icons'

import Divider from '@components/Divider'

import * as HomeStyle from '../../Home.style'
import * as WellnessStyle from './Wellness.style'

export default function Wellness() {
  return (
    <>
      <WellnessStyle.WellnessWrapper>
        <HomeStyle.Container>
          <Row>
            <Col xxs={12} xl={5}>
              <HomeStyle.Title>
                <FormattedMessage id="smb_acquisition_home.wellness.title" />
              </HomeStyle.Title>
              <HomeStyle.Subtitle>
                <FormattedMessage id="smb_acquisition_home.wellness.subtitle" />
              </HomeStyle.Subtitle>
            </Col>
            <Col xxs={12} xl-start={7} xl={6}>
              <WellnessStyle.Illustration
                src={homeExercising}
                alt="Um homem cartunizado fazendo ioga na sala dele com um sofá ao fundo."
              />
              <WellnessStyle.IllustrationDescription>
                <FormattedMessage
                  id="smb_acquisition_home.wellness.description"
                  values={{
                    strong: (...chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </WellnessStyle.IllustrationDescription>
            </Col>
          </Row>
        </HomeStyle.Container>
      </WellnessStyle.WellnessWrapper>

      <WellnessStyle.PartersWrapper>
        <HomeStyle.Container>
          <Row>
            <Col xxs={12} xl={3}>
              <WellnessStyle.Header>
                <FormattedMessage
                  id="smb_acquisition_home.featured_partners.gyms.title"
                  values={{
                    span: (...chunks) => <span>{chunks}</span>,
                  }}
                />
              </WellnessStyle.Header>
            </Col>

            <Col xxs={6} xl={2}>
              <WellnessStyle.PartnerIcon src={Bodytech} alt="Bodytech" />
            </Col>

            <Col xxs={6} xl={2}>
              <WellnessStyle.PartnerIcon
                src={CiaAthletica}
                alt="Cia Athletica"
              />
            </Col>

            <Col xxs={6} xl={2}>
              <WellnessStyle.PartnerIcon src={Bluefit} alt="Bluefit" />
            </Col>

            <Col xxs={6} xl={2}>
              <WellnessStyle.PartnerIcon src={DeRose} alt="De Rose" />
            </Col>
          </Row>

          <WellnessStyle.DividerWrapper>
            <Divider />
          </WellnessStyle.DividerWrapper>

          <Row>
            <Col xxs={12} xl={3}>
              <WellnessStyle.Header>
                <FormattedMessage
                  id="smb_acquisition_home.featured_partners.apps.title"
                  values={{
                    span: (...chunks) => <span>{chunks}</span>,
                  }}
                />
              </WellnessStyle.Header>
            </Col>

            <Col xxs={12} xl={2}>
              <WellnessStyle.PartnerIcon src={Zenklub} alt="Zenklub" />

              <WellnessStyle.PartnerWrapper>
                <WellnessStyle.PartnerTitle>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_1.title" />
                </WellnessStyle.PartnerTitle>

                <WellnessStyle.PartnerDescription>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_1.description" />
                </WellnessStyle.PartnerDescription>
              </WellnessStyle.PartnerWrapper>
            </Col>

            <Col xxs={12} xl={2}>
              <WellnessStyle.PartnerIcon src={Tecnonutri} alt="Tecnonutri" />

              <WellnessStyle.PartnerWrapper>
                <WellnessStyle.PartnerTitle>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_2.title" />
                </WellnessStyle.PartnerTitle>

                <WellnessStyle.PartnerDescription>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_2.description" />
                </WellnessStyle.PartnerDescription>
              </WellnessStyle.PartnerWrapper>
            </Col>

            <Col xxs={12} xl={2}>
              <WellnessStyle.PartnerIcon src={ZenThree} alt="ZenThree" />

              <WellnessStyle.PartnerWrapper>
                <WellnessStyle.PartnerTitle>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_3.title" />
                </WellnessStyle.PartnerTitle>

                <WellnessStyle.PartnerDescription>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_3.description" />
                </WellnessStyle.PartnerDescription>
              </WellnessStyle.PartnerWrapper>
            </Col>

            <Col xxs={12} xl={2}>
              <WellnessStyle.PartnerIcon src={BtfitThree} alt="Btfit" />

              <WellnessStyle.PartnerWrapper>
                <WellnessStyle.PartnerTitle>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_4.title" />
                </WellnessStyle.PartnerTitle>

                <WellnessStyle.PartnerDescription>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.apps.app_4.description" />
                </WellnessStyle.PartnerDescription>
              </WellnessStyle.PartnerWrapper>
            </Col>
          </Row>

          <WellnessStyle.DividerWrapper>
            <Divider />
          </WellnessStyle.DividerWrapper>

          <Row>
            <Col xxs={12} xl={3}>
              <WellnessStyle.Header>
                <FormattedMessage
                  id="smb_acquisition_home.featured_partners.personal_trainer.title"
                  values={{
                    span: (...chunks) => <span>{chunks}</span>,
                  }}
                />
              </WellnessStyle.Header>
            </Col>

            <Col xxs={12} xl={8}>
              <WellnessStyle.PartnerWrapper>
                <WellnessStyle.PartnerTitle>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.personal_trainer.personal_trainer_1.title" />
                </WellnessStyle.PartnerTitle>

                <WellnessStyle.PartnerDescription>
                  <FormattedMessage id="smb_acquisition_home.featured_partners.personal_trainer.personal_trainer_1.description" />
                </WellnessStyle.PartnerDescription>
              </WellnessStyle.PartnerWrapper>
            </Col>
          </Row>
        </HomeStyle.Container>
      </WellnessStyle.PartersWrapper>
    </>
  )
}
